/**
 * SP のみ: 下方向スクロールでヘッダーを隠し、上方向で再表示（先頭付近は常に表示）
 * 下部固定バナー等で縦幅が狭くなる対策。PC は変更なし。
 */
const SCROLL_TOP_THRESHOLD = 56;
const DELTA_MIN = 8;

export function init() {
	const mqSp = window.matchMedia('(max-width: 767px)');
	let lastScrollY = window.scrollY;
	let ticking = false;

	const clearHidden = () => {
		document.documentElement.classList.remove('is-sp-header-hidden');
	};

	const applyForViewport = () => {
		if (!mqSp.matches) {
			clearHidden();
		}
		lastScrollY = window.scrollY;
	};

	const update = () => {
		ticking = false;
		if (!mqSp.matches) return;

		const y = window.scrollY;

		if (y < SCROLL_TOP_THRESHOLD) {
			clearHidden();
			lastScrollY = y;
			return;
		}

		const delta = y - lastScrollY;
		if (Math.abs(delta) >= DELTA_MIN) {
			if (delta > 0) {
				document.documentElement.classList.add('is-sp-header-hidden');
			} else {
				clearHidden();
			}
		}
		lastScrollY = y;
	};

	const onScroll = () => {
		if (!mqSp.matches) return;
		if (!ticking) {
			ticking = true;
			window.requestAnimationFrame(update);
		}
	};

	applyForViewport();
	mqSp.addEventListener('change', applyForViewport);
	window.addEventListener('scroll', onScroll, { passive: true });

	const hamburger = document.querySelector('.js-hamburger');
	if (hamburger) {
		hamburger.addEventListener('click', () => {
			requestAnimationFrame(() => {
				if (hamburger.classList.contains('is-open')) {
					clearHidden();
				}
			});
		});
	}
}
